import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { HttpStatusCodeEnum } from '@/enums'
import { PlayerCardActionTypes } from '../constants'
import { PLAYER_CARD } from './api.routes'
import { getPlayerBalanceThunk } from './get-player-balance.thunk'

import { PlayerCardModels } from '../'

const apiService: RestApiService = Container.get(RestApiService)

export const setPlayerBalanceThunk = createAsyncThunk(
  PlayerCardActionTypes.SET_PLAYER_BALANCE,
  async (payload: PlayerCardModels.SetPlayerBalancePayload, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      apiService.requestParams = {
        method: 'POST',
        endpoint: PLAYER_CARD.SET_PLAYER_BALANCE,
        body: {
          ...payload,
        },
        isIncentiveAPI: false, // For the bonus engine API server
      }

      const response: any = await apiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      const { playerCard: playerCardSlice } =
        thunkAPI.getState() as ApplicationState
      const playerCard = playerCardSlice?.playerCard
      const playerName =
        playerCard && (playerCard.firstName || playerCard.lastName)
          ? `${playerCard.firstName || ''} ${playerCard.lastName || ''}`.trim()
          : playerCard?.username || payload.playerId

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('labels.player').toLowerCase()} ${playerName}`,
        what: i18n.t('messages.updated'),
      })

      const statusCode = response.statusCode || response.status
      const isError = statusCode && statusCode !== HttpStatusCodeEnum.OK

      if (isError) {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')
      } else {
        // Refresh player balance after success
        thunkAPI.dispatch(getPlayerBalanceThunk({ playerId: payload.playerId }))
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant: isError ? 'error' : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

export const setPlayerBalanceExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerCardModels.PlayerCardState>,
) => {
  builder.addCase(setPlayerBalanceThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(setPlayerBalanceThunk.fulfilled, (state) => {
    state.isLoading = false
  })
  builder.addCase(setPlayerBalanceThunk.rejected, (state) => {
    state.isLoading = false
  })
}
